export const toStanfordTaxLinkRequest = (mapping)=>mapping ? {
        taxReturnType: mapping.returnType,
        taxYear: mapping.taxYear
    } : {};
